import React from "react"
import { HugeLike } from ".."
import { 
  StyledArticleInformationWrapper,
    StyledAuthorInformationWrapper,
    StyledAuthorInformationContainer,
    StyledAuthorImageContainer,
    StyledAuthorImage,
    StyledAuthorDetailsContainer,
    StyledAuthorName,
    StyledAuthorRole,
    StyledAboutAuthor,
    StyledArticleHugeLikeButtonContainer
} from "./styled"

const AuthorInformation = ({ author: { avatar, name, role, about }, meta_url }) => {
  return (
    <StyledArticleInformationWrapper>
      <StyledAuthorInformationWrapper>
        <StyledAuthorInformationContainer>
          <StyledAuthorImageContainer>
            <StyledAuthorImage 
              alt={avatar.alternativeText} 
              src={avatar.formats.thumbnail.url} />
          </StyledAuthorImageContainer>
          <StyledAuthorDetailsContainer>
            <StyledAuthorName>{name}</StyledAuthorName>
            <StyledAuthorRole>{role}</StyledAuthorRole>
          </StyledAuthorDetailsContainer>
        </StyledAuthorInformationContainer>
      </StyledAuthorInformationWrapper>
      <StyledAboutAuthor>{about ?? ""}</StyledAboutAuthor>
      <StyledArticleHugeLikeButtonContainer>
        <HugeLike metaURL={meta_url} />
      </StyledArticleHugeLikeButtonContainer>
    </StyledArticleInformationWrapper>
  )
}

export default AuthorInformation
